import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Spinner from '../../shared/spinner.component';
import DropdownMenu from '../../shared/dropdownMenu';
import FileUploadButton from '../../shared/fileUpload/fileUploadButton.component';
import { acceptedExcelFileExtensions } from '../../shared/fileUpload/constants';

import { waitForSpinnerToShowUp } from '../../shared/cursorHelpers';

export default class HamburgerDropdown extends PureComponent {
  static propTypes = {
    exportToExcel: PropTypes.func.isRequired,
    fileToImportChange: PropTypes.func.isRequired,
    isFetching: PropTypes.bool,
  };

  state = {
    isGeneratingXlsxFile: false,
    isGeneratingXlsxFileForExport: false,
  };

  hideDropDown = () => {
    this.dropdown.hideDropDown();
  };

  exportToExcel = () => {
    this.setState({ isGeneratingXlsxFileForExport: true }, () => {
      waitForSpinnerToShowUp({
        action: this.props.exportToExcel,
        callback: () => this.setState({ isGeneratingXlsxFileForExport: false }),
      });
    });
  };

  renderChooseFileToImport = () => (
    <FileUploadButton
      accept={acceptedExcelFileExtensions}
      className="upload-file-button hamburger-action"
      onChange={this.props.fileToImportChange}
    >
      Choose File to Import
    </FileUploadButton>
  );

  renderExportToExcel = () => {
    const { isGeneratingXlsxFileForExport } = this.state;
    const { isFetching } = this.props;
    return (
      <button
        className="hamburger-action link-button"
        tabIndex="0"
        onClick={this.exportToExcel}
        disabled={isFetching}
      >
        { isGeneratingXlsxFileForExport
          ? (
            <span>
              <Spinner small /> Exporting
            </span>
          ) : 'Export to Excel'
        }
      </button>
    );
  };

  render() {
    return (
      <DropdownMenu ref={dropdown => this.dropdown = dropdown} contentClassName="hamburger-menu">
        {this.renderExportToExcel()}
        {this.renderChooseFileToImport()}
      </DropdownMenu>
    );
  }
}
